import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const ImageWoman = ({ className }) => {
  const data = useStaticQuery(graphql`
    {
      image: file(
        relativePath: {
          eq: "blog/woman-in-pink-long-sleeve-shirt-holding-silver-laptop-rect.jpg"
        }
      ) {
        childImageSharp {
          gatsbyImageData(
            width: 500
            placeholder: DOMINANT_COLOR
            layout: CONSTRAINED
          )
        }
      }
    }
  `)

  return <GatsbyImage image={getImage(data.image)} className={className} />
}

export default ImageWoman
